module.exports = __webpack_public_path__ + "static/img/103355.24c3db6b.png";